// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__nFqNd","tab":"Tabs_tab__qh8o6","tabActive":"Tabs_tabActive__1_DYY"};